import { Response } from '@marketplace-web/shared/api-client'

import { transformShipmentInstructions } from '../shipment-instructions'
import { ShipmentInstructionsResponse } from '../../types/shipment-instructions'

export const transformShipmentInstructionsResponse = (
  response: Response<ShipmentInstructionsResponse>,
) => transformShipmentInstructions(response.shipment_instructions)
